import { render, staticRenderFns } from "./ValueTreeFieldType6.vue?vue&type=template&id=a4450644&scoped=true"
import script from "./ValueTreeFieldType6.vue?vue&type=script&lang=js"
export * from "./ValueTreeFieldType6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4450644",
  null
  
)

export default component.exports